import { AccessType } from '@modules/access/types';
import { TPathItem } from '../items/types/folders.types';
import { EDetectionStatus } from './types/shared.types';
import { TERMINOLOGY } from '@shared/i18n';

// --- shared
export const FAILED_DETECTION_STATUS = [EDetectionStatus.ANALYSIS_FAILED, EDetectionStatus.INSERTION_FAILED];
export const DETECTIONS_TABLE_COLUMN_IDS = ['detected', 'arrow', 'referenced'];
export const DETECTIONS_TABLE_SIZING_PARAMS = {
  autoFitColumns: false,
  columnSizingOptions: {
    detected: { idealWidth: 400, minWidth: 200 },
    arrow: { defaultWidth: 75 },
    referenced: { idealWidth: 150, minWidth: 100 },
  },
} as const;

// --- references
export const FULL_PATH_REFERENCE_DETECTION_ITEM: TPathItem = Object.freeze({
  _id: 'reference-detection',
  name: `${TERMINOLOGY.reference.upper} detection`,
  accessRight: AccessType.MANAGE, // only global admins can use the reference detection
});
export const REFERENCE_DETECTION_PREVIEW_TABLE_ID = 'reference-detection-preview-table';

// --- inline blocks
export const FULL_PATH_INLINE_BLOCK_DETECTION_ITEM: TPathItem = Object.freeze({
  _id: 'inline-block-detection',
  name: 'Library detection',
  accessRight: AccessType.MANAGE, // only global admins can use detections
});
export const INLINE_BLOCK_DETECTION_PREVIEW_TABLE_ID = 'inline-block-detection-preview-table';
